import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import { listObjectsToListIds, listToObject } from "./paginationTools";
import { successToast, errorToast } from "data-handler/ducks/toast";
import { toastFormattedMessages } from "SCConstants";
import { camelToSnakeCase } from "./utils";
import { downloadBlob } from "data-handler/ducks/utils";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

export const ADMIN_VENDORS_REQUEST = "schoolconnect/vendors/VENDORS_REQUEST";
export const ADMIN_VENDORS_SUCCESS = "schoolconnect/vendors/VENDORS_SUCCESS";
export const ADMIN_VENDORS_FAILURE = "schoolconnect/vendors/VENDORS_FAILURE";

export const PENDING_ADMIN_VENDORS_REQUEST =
  "schoolconnect/vendors/PENDING_VENDORS_REQUEST";
export const PENDING_ADMIN_VENDORS_SUCCESS =
  "schoolconnect/vendors/PENDING_VENDORS_SUCCESS";
export const PENDING_ADMIN_VENDORS_FAILURE =
  "schoolconnect/vendors/PENDING_VENDORS_FAILURE";

export const VENDORS_IMPORTS_REQUEST =
  "schoolconnect/vendors/VENDORS_IMPORTS_REQUEST";
export const VENDORS_IMPORTS_SUCCESS =
  "schoolconnect/vendors/VENDORS_IMPORTS_SUCCESS";
export const VENDORS_IMPORTS_FAILURE =
  "schoolconnect/vendors/VENDORS_IMPORTS_FAILURE";

export const IMPORT_VENDOR_CSV_FILE_REQUEST =
  "schoolconnect/vendors/IMPORT_VENDOR_CSV_FILE_REQUEST";
export const IMPORT_VENDOR_CSV_FILE_SUCCESS =
  "schoolconnect/vendors/IMPORT_VENDOR_CSV_FILE_SUCCESS";
export const IMPORT_VENDOR_CSV_FILE_FAILURE =
  "schoolconnect/vendors/IMPORT_VENDOR_CSV_FILE_FAILURE";

export const DOWNLOAD_VENDOR_CSV_TEMPLATE_REQUEST =
  "schoolconnect/vendors/DOWNLOAD_VENDOR_CSV_TEMPLATE_REQUEST";
export const DOWNLOAD_VENDOR_CSV_TEMPLATE_SUCCESS =
  "schoolconnect/vendors/DOWNLOAD_VENDOR_CSV_TEMPLATE_SUCCESS";
export const DOWNLOAD_VENDOR_CSV_TEMPLATE_FAILURE =
  "schoolconnect/vendors/DOWNLOAD_VENDOR_CSV_TEMPLATE_FAILURE";

export const ALL_APPROVED_VENDORS_REQUEST =
  "schoolconnect/vendors/ALL_APPROVED_VENDORS_REQUEST";
export const ALL_APPROVED_VENDORS_SUCCESS =
  "schoolconnect/vendors/ALL_APPROVED_VENDORS_SUCCESS";
export const ALL_APPROVED_VENDORS_FAILURE =
  "schoolconnect/vendors/ALL_APPROVED_VENDORS_FAILURE";

export const VENDOR_CATEGORY_REQUEST =
  "schoolconnect/vendors/VENDOR_CATEGORY_REQUEST";
export const VENDOR_CATEGORY_SUCCESS =
  "schoolconnect/vendors/VENDOR_CATEGORY_SUCCESS";
export const VENDOR_CATEGORY_FAILURE =
  "schoolconnect/vendors/VENDOR_CATEGORY_FAILURE";

export const PERFORM_VENDOR_ACTION_REQUEST =
  "schoolconnect/vendors/PERFORM_VENDOR_ACTION_REQUEST";
export const PERFORM_VENDOR_ACTION_SUCCESS =
  "schoolconnect/vendors/PERFORM_VENDOR_ACTION_SUCCESS";
export const PERFORM_VENDOR_ACTION_FAILURE =
  "schoolconnect/vendors/PERFORM_VENDOR_ACTION_FAILURE";

export const CREATE_VENDOR_REQUEST =
  "schoolconnect/vendors/CREATE_VENDOR_REQUEST";
export const CREATE_VENDOR_SUCCESS =
  "schoolconnect/vendors/CREATE_VENDOR_SUCCESS";
export const CREATE_VENDOR_FAILURE =
  "schoolconnect/vendors/CREATE_VENDOR_FAILURE";

export const CURRENT_ADMIN_VENDOR_REQUEST =
  "schoolconnect/vendors/CURRENT_ADMIN_VENDOR_REQUEST";
export const CURRENT_ADMIN_VENDOR_SUCCESS =
  "schoolconnect/vendors/CURRENT_ADMIN_VENDOR_SUCCESS";
export const CURRENT_ADMIN_VENDOR_FAILURE =
  "schoolconnect/vendors/CURRENT_ADMIN_VENDOR_FAILURE";

export const EDIT_VENDOR_REQUEST = "schoolconnect/vendors/EDIT_VENDOR_REQUEST";
export const EDIT_VENDOR_SUCCESS = "schoolconnect/vendors/EDIT_VENDOR_SUCCESS";
export const EDIT_VENDOR_FAILURE = "schoolconnect/vendors/EDIT_VENDOR_FAILURE";

export const CURRENT_VENDORS_IMPORT_REQUEST =
  "schoolconnect/vendors/CURRENT_VENDORS_IMPORT_REQUEST";
export const CURRENT_VENDORS_IMPORT_SUCCESS =
  "schoolconnect/vendors/CURRENT_VENDORS_IMPORT_SUCCESS";
export const CURRENT_VENDORS_IMPORT_FAILURE =
  "schoolconnect/vendors/CURRENT_VENDORS_IMPORT_FAILURE";

export const VENDOR_IMPORT_RECORDS_REQUEST =
  "schoolconnect/vendors/VENDOR_IMPORT_RECORDS_REQUEST";
export const VENDOR_IMPORT_RECORDS_SUCCESS =
  "schoolconnect/vendors/VENDOR_IMPORT_RECORDS_SUCCESS";
export const VENDOR_IMPORT_RECORDS_FAILURE =
  "schoolconnect/vendors/VENDOR_IMPORT_RECORDS_FAILURE";

export const VENDORS_FOR_CSV_TEMPLATE_REQUEST =
  "schoolconnect/vendors/VENDORS_FOR_CSV_TEMPLATE_REQUEST";
export const VENDORS_FOR_CSV_TEMPLATE_SUCCESS =
  "schoolconnect/vendors/VENDORS_FOR_CSV_TEMPLATE_SUCCESS";
export const VENDORS_FOR_CSV_TEMPLATE_FAILURE =
  "schoolconnect/vendors/VENDORS_FOR_CSV_TEMPLATE_FAILURE";

export const CLEAR_VENDORS_FOR_CSV_TEMPLATE =
  "schoolconnect/vendors/CLEAR_VENDORS_FOR_CSV_TEMPLATE";

const initialState = {
  fetching: false,
  error: null,
  errorResponse: null,
  index: {},
  allApprovedVendorsList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  adminVendorsList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  pendingAdminVendorsList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  vendorsImportsList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  vendorsImportRecords: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  vendorsForCsvTemplate: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  vendorCategoryList: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  currentAdminVendor: undefined,
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case ALL_APPROVED_VENDORS_REQUEST:
    case ADMIN_VENDORS_REQUEST:
    case PENDING_ADMIN_VENDORS_REQUEST:
    case VENDORS_IMPORTS_REQUEST:
    case IMPORT_VENDOR_CSV_FILE_REQUEST:
    case DOWNLOAD_VENDOR_CSV_TEMPLATE_REQUEST:
    case CURRENT_VENDORS_IMPORT_REQUEST:
    case VENDOR_IMPORT_RECORDS_REQUEST:
    case VENDORS_FOR_CSV_TEMPLATE_REQUEST:
    case CURRENT_ADMIN_VENDOR_REQUEST:
      return { ...state, fetching: true, error: null };
    case ALL_APPROVED_VENDORS_FAILURE:
    case ADMIN_VENDORS_FAILURE:
    case PENDING_ADMIN_VENDORS_FAILURE:
    case VENDORS_IMPORTS_FAILURE:
    case IMPORT_VENDOR_CSV_FILE_FAILURE:
    case DOWNLOAD_VENDOR_CSV_TEMPLATE_FAILURE:
    case CURRENT_VENDORS_IMPORT_FAILURE:
    case VENDOR_IMPORT_RECORDS_FAILURE:
    case VENDORS_FOR_CSV_TEMPLATE_FAILURE:
    case CURRENT_ADMIN_VENDOR_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
        errorResponse: action.error.response,
      };
    case ALL_APPROVED_VENDORS_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        allApprovedVendorsList: action.data,
      };
    case ADMIN_VENDORS_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        adminVendorsList: action.data,
      };
    case PENDING_ADMIN_VENDORS_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        pendingAdminVendorsList: action.data,
      };
    case VENDORS_IMPORTS_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        vendorsImportsList: action.data,
      };
    case IMPORT_VENDOR_CSV_FILE_SUCCESS:
    case DOWNLOAD_VENDOR_CSV_TEMPLATE_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
      };
    case CURRENT_VENDORS_IMPORT_SUCCESS: {
      const { currentVendorsImport } = action;
      const currentVendorsImportObject = {
        [currentVendorsImport.id]: currentVendorsImport,
      };
      return {
        ...state,
        vendorsImportsList: {
          ...state.vendorsImportsList,
          results: {
            ...state.vendorsImportsList.results,
            ...currentVendorsImportObject,
          },
        },
        fetching: false,
        error: null,
      };
    }
    case VENDOR_IMPORT_RECORDS_SUCCESS:
      return {
        ...state,
        vendorsImportRecords: action.data,
        fetching: false,
        error: null,
      };
    case VENDORS_FOR_CSV_TEMPLATE_SUCCESS:
      return {
        ...state,
        vendorsForCsvTemplate: action.data,
        fetching: false,
        error: null,
      };
    case CLEAR_VENDORS_FOR_CSV_TEMPLATE:
      return {
        ...state,
        vendorsForCsvTemplate: {
          count: 0,
          next: null,
          previous: null,
          results: [],
        },
      };
    case CURRENT_ADMIN_VENDOR_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        currentAdminVendor: action.currentVendor,
      };
    case VENDOR_CATEGORY_REQUEST:
    case CREATE_VENDOR_REQUEST:
    case EDIT_VENDOR_REQUEST:
      return { ...state, fetching: true, error: null };
    case VENDOR_CATEGORY_FAILURE:
    case CREATE_VENDOR_FAILURE:
    case EDIT_VENDOR_FAILURE:
      return {
        ...state,
        fetching: false,
        error: action.error,
        errorResponse: action.error.response,
      };
    case VENDOR_CATEGORY_SUCCESS:
    case CREATE_VENDOR_SUCCESS:
    case EDIT_VENDOR_SUCCESS:
      return {
        ...state,
        fetching: false,
        error: null,
        ...(action.type === VENDOR_CATEGORY_SUCCESS
          ? { vendorCategoryList: action.data }
          : {}),
      };
    default:
      return state;
  }
}

function postImportVendorCsvFile(action) {
  const { file, countryId, isUpdate } = action;
  let formData = new FormData();

  formData.append("csv_file", file);
  formData.append("country", countryId);
  formData.append("is_update", isUpdate);

  const url = `${process.env.REACT_APP_API_URL}/vendor-imports/`;

  return axios({
    method: "post",
    url: url,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: formData,
  });
}

function* importVendorCsvFileSagaWorker(action) {
  try {
    const response = yield call(postImportVendorCsvFile, action);
    const responseData = response.data;
    yield put({ type: IMPORT_VENDOR_CSV_FILE_SUCCESS, responseData });
    yield put(successToast());
    window.location.reload();
  } catch (error) {
    yield put({ type: IMPORT_VENDOR_CSV_FILE_FAILURE, error });
    yield put(
      errorToast(
        toastFormattedMessages.find((e) => e.name === "toast.infomationError")
          .label
      )
    );
  }
}

function fetchVendorCsvTemplate() {
  const url = `${process.env.REACT_APP_API_URL}/vendor-imports/download-template/`;

  return axios({
    method: "GET",
    url: url,
    responseType: "blob",
  });
}

function* downloadVendorCsvTemplateSagaWorker(action) {
  try {
    const response = yield call(fetchVendorCsvTemplate, action);
    const blob = response.data;
    downloadBlob(blob, "Vendor_Reg_File_Template.csv");
    yield put({ type: DOWNLOAD_VENDOR_CSV_TEMPLATE_SUCCESS });
  } catch (error) {
    yield put({ type: DOWNLOAD_VENDOR_CSV_TEMPLATE_FAILURE, error });
    yield put(
      errorToast(
        toastFormattedMessages.find((e) => e.name === "toast.infomationError")
          .label
      )
    );
  }
}

function fetchPendingAdminVendors(action) {
  const page_size = action.pageSize;
  const page = action.pageIndex * page_size - page_size;
  const filters = action.filters;
  const ordering = action.ordering.replace(/\./g, "_");

  const url =
    `${process.env.REACT_APP_API_URL}/vendors/pending-vendors/` +
    `?limit=${page_size}&offset=${page}` +
    (ordering ? `&ordering=${ordering}` : "") +
    (filters && filters.length
      ? filters
          .map((filter) => {
            const id = filter.id;
            const value = filter.value;
            if (value && value !== "") {
              return `&${id}=${value}`;
            }
            return "";
          })
          .join("")
      : "");

  return axios({
    method: "GET",
    url: url,
  });
}

function fetchVendorsImport(action) {
  const url = `${process.env.REACT_APP_API_URL}/vendor-imports/${action.vendorsImportId}/`;
  return axios({
    method: "GET",
    url: url,
  });
}

function fetchVendorsImportRecords(action) {
  const page_size = action.pageSize;
  const page = action.pageIndex * page_size - page_size;
  const ordering = action.ordering.replace(/\./g, "_");
  const vendorsImportId = action.vendorsImportId;

  const url =
    `${process.env.REACT_APP_API_URL}/vendor-import-records/` +
    `?limit=${page_size}&offset=${page}` +
    (ordering ? `&ordering=${ordering}` : "") +
    (vendorsImportId ? `&vendor_import=${vendorsImportId}` : "");

  return axios({
    method: "GET",
    url: url,
  });
}

function fetchVendorsImports(action) {
  const page_size = action.pageSize;
  const page = action.pageIndex * page_size - page_size;
  const filters = action.filters;
  const ordering = action.ordering.replace(/\./g, "_");

  const url =
    `${process.env.REACT_APP_API_URL}/vendor-imports/` +
    `?limit=${page_size}&offset=${page}` +
    (ordering ? `&ordering=${ordering}` : "") +
    (filters && filters.length
      ? filters
          .map((filter) => {
            const id = filter.id;
            const value = filter.value;
            if (value && value !== "") {
              return `&${id}=${value}`;
            }
            return "";
          })
          .join("")
      : "");

  return axios({
    method: "GET",
    url: url,
  });
}

function fetchGetVendor(vendorId) {
  const url = `${process.env.REACT_APP_API_URL}/vendors/${vendorId.data}/`;
  return axios({
    method: "GET",
    url: url,
  });
}

function* currentAdminVendorSagaWorker(action) {
  try {
    const response = yield call(fetchGetVendor, action);
    const currentVendor = response.data;
    yield put({ type: CURRENT_ADMIN_VENDOR_SUCCESS, currentVendor });
  } catch (error) {
    const { history } = action;
    history.push(`/countryAdmin/vendors/allVendors`);
    yield put({ type: CURRENT_ADMIN_VENDOR_FAILURE, error });
  }
}

function putVendor(action) {
  const url = `${process.env.REACT_APP_API_URL}/vendors/${action.id}/`;

  return axios(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(action.data),
  });
}

function* editVendorSagaWorker(action) {
  try {
    const { history } = action;
    yield call(putVendor, action);

    yield put({ type: EDIT_VENDOR_SUCCESS });
    yield put(successToast());
    history.push("/countryAdmin/vendors/allVendors");
  } catch (error) {
    yield put({ type: EDIT_VENDOR_FAILURE, error });
    yield put(
      errorToast(
        toastFormattedMessages.find((e) => e.name === "toast.infomationError")
          .label
      )
    );
  }
}

const persistedReducer = persistReducer(
  {
    key: "vendors",
    storage,
    blacklist: ["error", "errorResponse", "fetching", "currentAdminVendor"],
  },
  reducer
);

export default persistedReducer;

export const getAdminVendors = (state) => state.vendors.adminVendorsList;
export const getPendingAdminVendors = (state) =>
  state.vendors.pendingAdminVendorsList;
export const getVendorsImports = (state) => state.vendors.vendorsImportsList;
export const getVendorsImportRecords = (state) =>
  state.vendors.vendorsImportRecords;
export const getVendorsForCsvTemplate = (state) =>
  state.vendors.vendorsForCsvTemplate;
export const getAllApprovedVendors = (state) =>
  state.vendors.allApprovedVendorsList;
export const getVendorCategories = (state) => state.vendors.vendorCategoryList;
export const getCurrentAdminVendor = (state) =>
  state.vendors.currentAdminVendor;
export const getIsVendorCategoriesFetching = (state) => state.vendors.fetching;
export const getVendorCategoriesError = (state) => state.vendors.error;
export const requestAdminVendors = (pageSize, pageIndex, ordering, filters) => {
  return {
    type: ADMIN_VENDORS_REQUEST,
    pageSize,
    pageIndex,
    ordering,
    filters,
  };
};

export const requestPendingAdminVendors = (
  pageSize,
  pageIndex,
  ordering,
  filters
) => ({
  type: PENDING_ADMIN_VENDORS_REQUEST,
  pageSize,
  pageIndex,
  ordering,
  filters,
});

export const requestCurrentVendorsImport = (vendorsImportId, history) => ({
  type: CURRENT_VENDORS_IMPORT_REQUEST,
  vendorsImportId,
  history,
});

export const requestVendorsImportRecords = (
  pageSize,
  pageIndex,
  ordering,
  vendorsImportId
) => ({
  type: VENDOR_IMPORT_RECORDS_REQUEST,
  pageSize,
  pageIndex,
  ordering,
  vendorsImportId,
});

export const requestVendorsForCsvTemplate = (
  pageSize,
  pageIndex,
  ordering,
  filters
) => ({
  type: VENDORS_FOR_CSV_TEMPLATE_REQUEST,
  pageSize,
  pageIndex,
  ordering,
  filters,
});

export const clearVendorsForCsvTemplate = () => ({
  type: CLEAR_VENDORS_FOR_CSV_TEMPLATE,
});

export const importVendorCsvFile = (file, countryId, isUpdate) => ({
  type: IMPORT_VENDOR_CSV_FILE_REQUEST,
  file,
  countryId,
  isUpdate,
});

export const downloadVendorCsvTemplate = () => ({
  type: DOWNLOAD_VENDOR_CSV_TEMPLATE_REQUEST,
});

export const requestVendorsImports = (
  pageSize,
  pageIndex,
  ordering,
  filters
) => ({
  type: VENDORS_IMPORTS_REQUEST,
  pageSize,
  pageIndex,
  ordering,
  filters,
});

export const requestVendorCategories = () => ({
  type: VENDOR_CATEGORY_REQUEST,
});

export const requestAllApprovedVendors = (countryId) => ({
  type: ALL_APPROVED_VENDORS_REQUEST,
  countryId,
});

export const performVendorAction = (actionLabel, vendorId) => ({
  type: PERFORM_VENDOR_ACTION_REQUEST,
  actionLabel,
  vendorId,
});

export const createVendor = (data, history) => ({
  type: CREATE_VENDOR_REQUEST,
  data,
  history,
});

export const requestCurrentAdminVendor = (data, history) => ({
  type: CURRENT_ADMIN_VENDOR_REQUEST,
  data,
  history,
});

export const editVendor = (data, id, history) => ({
  type: EDIT_VENDOR_REQUEST,
  data,
  id,
  history,
});
export function* adminVendorsSagaWatcher() {
  yield takeLatest(ADMIN_VENDORS_REQUEST, adminVendorsSagaWorker);
}

export function* pendingAdminVendorsSagaWatcher() {
  yield takeLatest(
    PENDING_ADMIN_VENDORS_REQUEST,
    pendingAdminVendorsSagaWorker
  );
}

export function* vendorsImportsSagaWatcher() {
  yield takeLatest(VENDORS_IMPORTS_REQUEST, vendorsImportsSagaWorker);
}

export function* requestCurrentVendorsImportSagaWatcher() {
  yield takeLatest(
    CURRENT_VENDORS_IMPORT_REQUEST,
    requestCurrentVendorsImportSagaWorker
  );
}

export function* requestVendorsImportRecordsSagaWatcher() {
  yield takeLatest(
    VENDOR_IMPORT_RECORDS_REQUEST,
    requestVendorsImportRecordsSagaWorker
  );
}

export function* vendorsForCsvTemplateSagaWatcher() {
  yield takeLatest(
    VENDORS_FOR_CSV_TEMPLATE_REQUEST,
    vendorsForCsvTemplateSagaWorker
  );
}

export function* importVendorCsvFileSagaWatcher() {
  yield takeLatest(
    IMPORT_VENDOR_CSV_FILE_REQUEST,
    importVendorCsvFileSagaWorker
  );
}

export function* downloadVendorCsvTemplateSagaWatcher() {
  yield takeLatest(
    DOWNLOAD_VENDOR_CSV_TEMPLATE_REQUEST,
    downloadVendorCsvTemplateSagaWorker
  );
}

export function* allApprovedVendorsSagaWatcher() {
  yield takeLatest(ALL_APPROVED_VENDORS_REQUEST, allApproveVendorsSagaWorker);
}
export function* vendorCategoriesSagaWatcher() {
  yield takeLatest(VENDOR_CATEGORY_REQUEST, vendorCategoriesSagaWorker);
}

export function* performVendorActionSagaWatcher() {
  yield takeLatest(
    PERFORM_VENDOR_ACTION_REQUEST,
    performVendorActionSagaWorker
  );
}

export function* createVendorSagaWatcher() {
  yield takeLatest(CREATE_VENDOR_REQUEST, createVendorSagaWorker);
}

export function* currentAdminVendorSagaWatcher() {
  yield takeLatest(CURRENT_ADMIN_VENDOR_REQUEST, currentAdminVendorSagaWorker);
}

export function* editVendorSagaWatcher() {
  yield takeLatest(EDIT_VENDOR_REQUEST, editVendorSagaWorker);
}

function fetchVendors(action) {
  const page_size = action.pageSize;
  const page = action.pageIndex * page_size - page_size;
  const filters = action.filters;
  const ordering = action.ordering.replace(/\./g, "_");
  const { countryId } = action;
  const url =
    `${process.env.REACT_APP_API_URL}/vendors/` +
    `?limit=${page_size}&offset=${page}` +
    (ordering ? `&ordering=${ordering}` : "") +
    (filters && filters.length
      ? filters
          .map((filter) => {
            const id = filter.id;
            const value = filter.value;
            if (value && value !== "") {
              return `&${id}=${value}`;
            }
            return "";
          })
          .join("")
      : "");
  const params = {
    country: countryId,
  };
  return axios({
    method: "GET",
    url: url,
    params,
  });
}

function fetchAllApprovedVendors(action) {
  const { countryId } = action;
  const url = `${process.env.REACT_APP_API_URL}/vendors/`;
  const params = {
    country: countryId,
    state: "admin_approved",
    limit: 99999,
  };
  return axios({
    method: "GET",
    url: url,
    params,
  });
}

function* adminVendorsSagaWorker(action) {
  try {
    const response = yield call(fetchVendors, action);
    const results = listToObject(response.data.results, "id");
    const ids = listObjectsToListIds(response.data.results, "id");

    const data = {
      ...response.data,
      results,
      ids,
    };
    yield put({ type: ADMIN_VENDORS_SUCCESS, data });
  } catch (error) {
    yield put({ type: ADMIN_VENDORS_FAILURE, error });
  }
}

function* pendingAdminVendorsSagaWorker(action) {
  try {
    const response = yield call(fetchPendingAdminVendors, action);
    const results = listToObject(response.data.results, "id");
    const ids = listObjectsToListIds(response.data.results, "id");

    const data = {
      ...response.data,
      results,
      ids,
    };
    yield put({ type: PENDING_ADMIN_VENDORS_SUCCESS, data });
  } catch (error) {
    yield put({ type: PENDING_ADMIN_VENDORS_FAILURE, error });
  }
}

function* vendorsImportsSagaWorker(action) {
  try {
    const response = yield call(fetchVendorsImports, action);
    const results = listToObject(response.data.results, "id");
    const ids = listObjectsToListIds(response.data.results, "id");

    const data = {
      ...response.data,
      results,
      ids,
    };
    yield put({ type: VENDORS_IMPORTS_SUCCESS, data });
  } catch (error) {
    yield put({ type: VENDORS_IMPORTS_FAILURE, error });
  }
}

function* requestCurrentVendorsImportSagaWorker(action) {
  try {
    const response = yield call(fetchVendorsImport, action);
    const currentVendorsImport = response.data;
    yield put({ type: CURRENT_VENDORS_IMPORT_SUCCESS, currentVendorsImport });
  } catch (error) {
    const { history } = action;
    history.push(`/countryAdmin/vendors/vendorsImports`);
    yield put({ type: CURRENT_VENDORS_IMPORT_FAILURE, error });
  }
}

function* requestVendorsImportRecordsSagaWorker(action) {
  try {
    const response = yield call(fetchVendorsImportRecords, action);
    const results = listToObject(response.data.results, "id");
    const ids = listObjectsToListIds(response.data.results, "id");

    const data = {
      ...response.data,
      results,
      ids,
    };

    yield put({
      type: VENDOR_IMPORT_RECORDS_SUCCESS,
      data,
    });
  } catch (error) {
    yield put({ type: VENDOR_IMPORT_RECORDS_FAILURE, error });
  }
}

function* vendorsForCsvTemplateSagaWorker(action) {
  try {
    const response = yield call(fetchVendors, action);
    const results = listToObject(response.data.results, "id");
    const ids = listObjectsToListIds(response.data.results, "id");

    const data = {
      ...response.data,
      results,
      ids,
    };

    yield put({ type: VENDORS_FOR_CSV_TEMPLATE_SUCCESS, data });
  } catch (error) {
    yield put({ type: VENDORS_FOR_CSV_TEMPLATE_FAILURE, error });
  }
}

function* allApproveVendorsSagaWorker(action) {
  try {
    const response = yield call(fetchAllApprovedVendors, action);
    const data = {
      ...response.data,
    };
    yield put({ type: ALL_APPROVED_VENDORS_SUCCESS, data });
  } catch (error) {
    yield put({ type: ALL_APPROVED_VENDORS_FAILURE, error });
  }
}

function fetchVendorCategories() {
  const url = `${process.env.REACT_APP_API_URL}/vendor-categories/`;
  const params = {
    limit: 99999,
  };
  return axios({
    method: "GET",
    url: url,
    params,
  });
}

function* vendorCategoriesSagaWorker(action) {
  try {
    const response = yield call(fetchVendorCategories, action);
    const results = listToObject(response.data.results, "id");
    const ids = listObjectsToListIds(response.data.results, "id");

    const data = {
      ...response.data,
      results,
      ids,
    };
    yield put({ type: VENDOR_CATEGORY_SUCCESS, data });
  } catch (error) {
    yield put({ type: VENDOR_CATEGORY_FAILURE, error });
  }
}

function putVendorAction(action) {
  const { actionLabel, vendorId } = action;
  const perform = camelToSnakeCase(actionLabel);
  const url = `${process.env.REACT_APP_API_URL}/vendors/${vendorId}/perform/${perform}/`;
  return axios({
    method: "PUT",
    url: url,
  });
}

function* performVendorActionSagaWorker(action) {
  try {
    const response = yield call(putVendorAction, action);
    const data = response.data;

    yield put({
      type: PERFORM_VENDOR_ACTION_SUCCESS,
      data,
    });
    yield put(
      successToast(
        toastFormattedMessages.find(
          (e) => e.name === `toast.${action.actionLabel}Success`
        ).label
      )
    );
    window.location.reload();
  } catch (error) {
    // dispatch a failure action to the store with the error
    yield put({
      type: PERFORM_VENDOR_ACTION_FAILURE,
      error,
    });
    yield put(
      errorToast(
        toastFormattedMessages.find(
          (e) => e.name === `toast.${action.actionLabel}Error`
        ).label
      )
    );
  }
}

function postNewVendor(action) {
  const url = `${process.env.REACT_APP_API_URL}/vendors/`;

  return axios(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: JSON.stringify(action.data),
  });
}

function* createVendorSagaWorker(action) {
  try {
    const { history } = action;
    yield call(postNewVendor, action);

    yield put({ type: CREATE_VENDOR_SUCCESS });
    yield put(successToast());
    history.push("/countryAdmin/vendors/allVendors");
  } catch (error) {
    yield put({ type: CREATE_VENDOR_FAILURE, error });
    yield put(
      errorToast(
        toastFormattedMessages.find((e) => e.name === "toast.infomationError")
          .label
      )
    );
  }
}
